import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import checkIconRed from "../../resources/images/alert-circle.svg";

const styles = createUseStyles(theme => ({
  phoneInputWrapper: {
    width: '100%',
    //height: '44px !important',
    padding: '0 !important',
    border: `1px solid ${theme.field.borderColor} !important`,
    borderRadius: '8px !important',
    backgroundColor: ({ isDisabled }) => (isDisabled ? theme.field.backgroundColorDisabled : theme.field.backgroundColor),
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    position: 'relative',
    '&:focus-within': {
      borderColor: `${theme.field.borderColorFocus} !important`,
    },
  },
  countrySelect: {
    width: '64px',
    height: '100%',
    position: 'relative',
    overflow: 'visible',
  },
  phoneInput: {
    flex: 1,
    padding: '10px 14px',
    border: 'none !important',
    borderRadius: '0 8px 8px 0',
    fontSize: '16px',
    outline: 'none',
    height: '100%',
    boxSizing: 'border-box',
    fontFamily: 'Inter, sans-serif',
    minHeight: '42px',
    '&:disabled': {
      color: colors.inactiveGrey,
      backgroundColor: colors.brightBlue,
    },
  },
  inputError: {
    border: "1px solid " + theme.field.borderColorError + " !important",
    boxShadow: 'none !important',
    backgroundSize: "16px 16px",
    backgroundPosition: "right 12px center",
    backgroundRepeat: "no-repeat",
    backgroundOrigin: "content-box",
    backgroundImage: `url(${checkIconRed})`,
    '&:focus-within': {
      borderColor: `${theme.field.borderColorError} !important`,
    },
  }
}));

export default styles;

export const countrySelectStyles = (theme) => ({
  menu: (base) => ({
    ...base,
    borderRadius: "8px",
    marginTop: "4px",
    width: "240px",
  }),
  menuList: (base) => ({
    ...base,
    height: "180px"
  }),
  option: (base, state) => {
    const displayBorder = () => {
      return (
        state.data.countryPhoneCode &&
        state.options?.length > 2 &&
        state.data.value === "CA" &&
        !state?.selectProps?.inputValue
      );
    };
    return {
      ...base,
      cursor: "pointer",
      overflow: "hidden",
      img: {
        display: state.isSelected ? "inline" : "none",
        marginLeft: "6px",
      },
      display: "flex",
      padding: "10px 8px",
      backgroundColor: state.isSelected ? theme.field.backgroundColorHover : (state.isFocused ? theme.field.backgroundColorFocus : theme.field.backgroundColor),
      borderRadius: "6px",
      color: theme.field.textColor,
      "&:hover": {
        backgroundColor: colors.brightBlue,
      },
      "& span": {
        color: colors.mediumGrey,
        marginLeft: "5px",
      },
      "& img": {
        marginLeft: "auto",
      },
      position: "relative",
      "&::after": {
        content: '""',
        display: "block",
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        borderBottom: displayBorder() ? "1px solid " + colors.lightGrey : "0px transparent",
      },
    };
  },
  control: (base) => ({
    ...base,
    height: "42px",
    width: "65px",
    border: 'none',
    borderRight: `1px solid ${theme.field.borderColor}`,
    borderRadius: "8px 0px 0px 8px",
    borderColor: theme.field.borderColor,
    "&:hover": {
      borderColor: theme.field.borderColor,
    },
    // Removes weird border around container
    boxShadow: null,
    minHeight: "40px",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0px",
    height: "44px",
    marginLeft: "12px",
  }),
  input: (base) => ({
    ...base,
    height: "44px",
    minWidth: "40px",
    margin: "0px",
    padding: "0px",
  }),
  singleValue: (base) => ({
    ...base,
    marginLeft: "0px",
    marginRight: "8px",
    padding: "0px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0",
    color: colors.inactiveGrey,
    "&:hover": {
      color: colors.inactiveGrey,
    },
  }),
  indicatorsContainer: (base) => ({
    ...base,
    width: "22px",
  }),
});
